














































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import TagAPI from '@/services/TagAPI';

import Tag from '@/types/Tag';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import Loader from '@/components/Loader.vue';
import Util from '@/util/Util';

export default Vue.extend({
    name: 'TagEditor',

    components: {
        Field,
        TInput,
        Loader
    },

    data() {
        return {
            tag: new Tag(),
            error: {
                save: ''
            },
            status: '',
            isLoading: false,
            isSaving: false,
            isLoadingEdit: false
        };
    },

    computed: {
        ...mapState(['language', 'tags']),

        ...mapGetters(['getSiteSupportedLanguageCountries'])
    },

    created() {
        this.loadTags();
        this.tag = this.newTag();
    },

    methods: {
        postTag(): void {
            const handleResponse = (response: AxiosResponse) => {
                    this.tag = this.newTag();
                    this.loadTags();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isSaving = true;
            TagAPI
                .postTag(this.tag)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isSaving = false);
        },

        loadTags(): void {
            const handleResponse = (response: AxiosResponse) => {
                    this.$store.commit('setTags', response.data);
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoading = true;
            TagAPI
                .getTags()
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        deleteTag(tagId: string): void {
            if (!confirm('Are you sure you want to delete this tag? It will disappear from all Products and Items.')) {
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    this.tag = this.newTag();
                    this.loadTags();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            TagAPI
                .delete(tagId)
                .then(handleResponse)
                .catch(handleError);
        },

        editTag(tag: Tag): void {
            this.tag = tag;
        },

        newTag(): Tag {
            const tag = new Tag();
            tag.tagText = new Map<string, string>();
            return tag;
        },

        isObjectId(tagId: string): boolean {
            return Util.isObjectId(tagId);
        },

        updateTag(): void {
            if (!Util.isObjectId(this.tag.tagId)) {
                alert('You have to select a tag to update');
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    this.tag = this.newTag();
                    this.loadTags();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoadingEdit = true;
            TagAPI
                .updateTagText(this.tag.tagId, this.tag)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoadingEdit = false);
        }
    }
});
